import { globalT, globalTE } from "@/config/i18n";
import { Contact, ContactGroup, ContactGroupViewModel, PatientViewModel, SelectItem } from "@/store/classes";
import axios from "axios";
import { DateTime } from "luxon";

export const MAX_32_BIT_SIGNED_INT = 2147483647;

export const enumToSelectItems = function(enumKeys: object|string[]|number[], enumName: string): SelectItem[] {
    const keys = Array.isArray(enumKeys) ? enumKeys : Object.keys(enumKeys);
    return keys.map(x => {
        const key = `enums.${enumName}.${x}`;
        return ({text: globalTE(key) ? globalT(key) : x, value: x}) as SelectItem;
    });
};

export const parseDate = function(date: string|undefined = ''): DateTime {
    let parsed = DateTime.fromFormat(date, 'MM/dd/yyyy');
    if (!parsed.isValid) parsed = DateTime.fromFormat(date, 'M/dd/yyyy');
    return parsed;
};

export function getFacilityI18n(labelKey: string, facilityType: string = '', params?: Record<string, unknown>) {
    const key = `${labelKey}.${facilityType}`;
    return globalT(globalTE(key) ? key : `${labelKey}.default`, params);
}


export const parseTime = function(time: string|undefined = ''): DateTime {
    let parsed= DateTime.fromFormat(time, 't');
    if (!parsed.isValid) parsed = DateTime.fromFormat(time, 'h:mm a');
    if (!parsed.isValid) parsed = DateTime.fromFormat(time, 'h:mma');
    if (!parsed.isValid) parsed = DateTime.fromFormat(time, 'hh:mm');
    if (!parsed.isValid) parsed = DateTime.fromFormat(time, 'h a');
    if (!parsed.isValid) parsed = DateTime.fromFormat(time, 'ha');
    return parsed;
};

export const getLocalJSDate = function(date: DateTime|undefined): Date|undefined {
    if (!date) return undefined;
    return date.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone, { keepLocalTime: true }).toJSDate();
}

export const buildCurrentDateRange = function(months: number): {startDate: DateTime; endDate: DateTime} {
    const today = DateTime.local().startOf('day');
    const startDate = today.startOf('month').minus({months});
    const endDate = today.plus({months: 1}).startOf('month').minus({seconds: 1});
    return {startDate, endDate};
}

export function scrollBottom() {
    const scrollingElement = (document.scrollingElement || document.body);
    scrollingElement.scrollTop = scrollingElement.scrollHeight;
}

export const searchContacts = async function(facilityId: number, recipientSearch: string): Promise<RecipientSelectItem[]> {
    if (!recipientSearch) return [];

    const [patientsResponse, groupsResponse] = await Promise.all([
        axios.get('/patients/query', {
            params: {
                facilityId: facilityId,
                nameSearch: recipientSearch,
                allowsDirectContact: true
            }
        }),
        axios.get('/contacts/groups/query', {
            params: {
                facilityId: facilityId,
                nameSearch: recipientSearch
            }
        })
    ]);
    let results: SelectItem[] = [];
    if (patientsResponse.data && patientsResponse.data.items.length) {
        results = results.concat(patientsResponse.data.items.map((x: PatientViewModel) => ({
            text: x.patient.firstName + ' ' + x.patient.lastName,
            value: x.patient.id,
            contact: x.patient
        })));
    }
    if (groupsResponse.data && groupsResponse.data.items.length) {
        results = results.concat(groupsResponse.data.items.map((x: ContactGroupViewModel) => ({
            text: x.contactGroup.contactGroupName,
            value: x.contactGroup.id,
            contactGroup: x.contactGroup
        })));
    }
    
    return results;
};

export interface RecipientSelectItem extends SelectItem {
    contact?: Contact;
    contactGroup?: ContactGroup;
}